/**
 * Kleine Formatierungs-Helpers fuer Listen-Spalten und KPIs.
 *
 * Wird (Stand MR Silos+Row-Counts) von CatalogList.tsx und Silos.tsx genutzt.
 * Bewusst klein gehalten und gut testbar — sie nehmen `null` an, weil unsere
 * Catalog-Felder oft optional sind.
 */

/**
 * Formatiert eine Ganzzahl in de-DE-Locale ("28.471"). `null`/`undefined`
 * werden als typografischer Em-Dash zurueckgegeben — das Frontend rendert
 * den Wert dann als dezenten Strich, statt eine Null vorzutaeuschen.
 */
export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat('de-DE').format(value);
}

/**
 * Formatiert Bytes in passender Einheit (KB / MB / GB / TB). Verwendet
 * 1024-er Schritten, gibt aber kurze SI-Suffixe aus — die UI ist nicht der
 * Ort fuer KiB-Diskussionen.
 *
 * Beispiele:
 *   - 0          → "0 B"
 *   - 512        → "512 B"
 *   - 8192       → "8 KB"
 *   - 1572864    → "1,5 MB"
 *   - null       → "—"
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—';
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let n = bytes / 1024;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i += 1;
  }
  return `${n.toLocaleString('de-DE', { maximumFractionDigits: 1 })} ${units[i]}`;
}
